<template>
  <v-container fluid>
    <v-card elevation="0">
      <!--Start Filter Section-->
      <v-row>
        <v-col class="py-0" cols="12" md="12" lg="12" sm="12">
          <v-card-text>
            <v-data-table
              class="ams-calender"
              :headers="headers"
              :items="amScheduleVisitList"
              disable-pagination
              hide-default-footer
              elevation="0"
              dense
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="(item, index) in items"
                    :key="index"
                    :class="
                      item.date.includes('Sat')
                        ? 'grey lighten-2'
                        : item.date.includes('Sun')
                        ? 'grey lighten-2'
                        : 'white'
                    "
                  >
                    <td v-for="(value, name, index) in item" :key="index">
                      <span
                        v-if="name !== 'date' && value === 'Available'"
                        class="green--text text--darken-4"
                      >
                        {{ value }}
                      </span>
                      <span
                        v-else-if="name !== 'date' && value === 'Not Available'"
                        class="red--text text-darken-3"
                      >
                        {{ value }}
                      </span>
                      <span v-else>
                        {{ value }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card-text>
        </v-col>
      </v-row>
      <!--End Filter Section-->
    </v-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import moment from 'moment'
export default {
  name: 'AMVisitScheduledCalender',
  props: {
    zoneID: {
      type: Number,
      default: null
    },
    amsVisitCalenderFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      zonalID: 0,
      zoneList: [],
      headers: [],
      amScheduleVisitList: []
    }
  },
  watch: {
    zoneID: function (newVal) {
      this.zonalID = parseInt(newVal)
    },
    amsVisitCalenderFlag: function (newVal) {
      if (newVal) {
        this.getZoneWiseAMSScheduleVisitCalender()
      }
    }
  },
  created: async function () {
    this.zonalID = parseInt(this.zoneID)
    this.getZoneWiseAMSScheduleVisitCalender()
  },
  methods: {
    getZoneWiseAMSScheduleVisitCalender: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.headers = []
        this.amScheduleVisitList = []
        let payload = {}
        payload.zoneID = this.zonalID
        const res = await http.post(
          `${constants.API_URL}/api/ams/get-am-visit-calendar`,
          payload
        )
        if (res.status === 200) {
          if (res.data.academicManagers) {
            this.headers.push({
              text: 'Date',
              class: 'blue darken-3',
              width: 150,
              value: 'date'
            })
            res.data.academicManagers.forEach((item) => {
              let amName = item.amName
              this.headers.push({
                text: amName,
                width: 200,
                value: amName.split(' ').join('_').toLowerCase()
              })
            })
          }
          res.data.amData.forEach((item) => {
            item.date = moment(new Date(item.date)).format('DD/MM/YYYY dddd')
          })
          this.amScheduleVisitList = res.data.amData
          this.loadingComponent.close()
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 4000
        })
      }
    }
  }
}
</script>

<style>
.ams-calender > div > table > tbody > tr > td:nth-child(1),
.ams-calender > div > table > thead > tr > th:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 1;
  background: #fff;
}
.ams-calender > div > table > thead > tr > th:nth-child(1) {
  z-index: 2;
}
.ams-calender > div {
  overflow-x: auto;
}
</style>
